module.exports = __webpack_public_path__ + "static/media/Previous.62c5110e.svg";